import base from "../../baseurl";
import token from "../../getTk";

const Create = async (name, background) => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  const newS = await api
    .post("sport-document-types/create", {
      json: { name, background },
      timeout: false,
    })
    .json();
  return newS;
};

export default Create;
